import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import logOutModals from 'src/app/core/constants/log-out-modals/logOutModals.json';
import { URLRedirect } from 'src/app/core/constants/URLRedirect';

@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css']
})
export class LogOutComponent implements OnInit {

  logOutWarningModal; 
  logOutInfoModal; 
  logOutEndModal; 

  titleModal:string;
  subtitleModal:string;

  textBtnUp: string;
  textBtnDown:string;

  iconModal:string

  orderModal:number = 0;

  logOutModalOptions: any = logOutModals;

  @Input()
  showMenu: boolean = false; 

  @Input()
  showBackButton: boolean = true;

  @Input()
  showLogOutButton: boolean = true;

  @Output()
  buttonBack= new EventEmitter<void>();

  @Output()
  returnSign= new EventEmitter<void>();
  
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    this.logOutWarningModal = false; 
    this.logOutInfoModal = false; 
    this.logOutEndModal = false; 
  }

  @Input() set logOutModal(logOut:boolean){
    if(logOut){
      this.logOutWarningModal = true;
      this.fillModals(this.orderModal);
    }
  }

  fillModals(modal:number){
    if(modal !== null){
      this.titleModal = this.logOutModalOptions[modal].titleModal;
      this.textBtnUp = this.logOutModalOptions[modal].textBtnUp;
      this.textBtnDown = this.logOutModalOptions[modal].textBtnDown;
      this.subtitleModal = this.logOutModalOptions[modal].subtitleModal;
      this.iconModal = this.logOutModalOptions[modal].iconModal
    }
  }

  modalOptionWarningSelect(event:number){
    this.logOutWarningModal = false
    if(event === 0){
      localStorage.clear()
      window.location.href = URLRedirect.exitRedirect
    }
    else{
      this.returnSign.emit();
    }
  }

  modalOptioInfoSelect(event:number){
    this.logOutInfoModal = false
    if(event === 0){
      console.log(this.textBtnUp)
    }
    else{
      console.log(this.textBtnDown)
    }
    // this.orderModal = this.orderModal+1;
    this.fillModals(this.orderModal);
    this.logOutEndModal= true
  }

  logOut(){
    this.logOutEndModal= false
    console.log("logOut")
    this.router.navigateByUrl('')
  }

  backMenu(){
    this.buttonBack.emit()
  }

}
